import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/shared/guards/auth.guard';
import { ServiceRequestComponent } from './components/service-request.component';
import { ServiceRequestDetailsComponent } from './components/service-request-details/service-request-details.component';
import { ServiceRequestAddAgentComponent } from './components/service-request-add-agent/service-request-add-agent.component';

const routes: Routes = [
  {
    path: 'serviceRequest/list',
    component: ServiceRequestComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Ordens de Serviço'
    },
  },
  {
    path: 'serviceRequest/details',
    component: ServiceRequestDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Nova Solicitação de Serviço'
    }
  },
  {
    path: 'serviceRequest/add-agent',
    component: ServiceRequestAddAgentComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Associação de Técnico'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceRequestRoutingModule { }
